import { React } from 'react';
import "./ShowPage.css"
import showInfo from "./ShowInfo.json"
import ShowCard from "./ShowCard"
import Navbar from './../Navbar';


function ShowPage() {

  return (
    <div className="background">
      <Navbar />
      <div className="overlay">
        <div className="content">
          {/* {showInfo.shows.map((show, index) => (
            <ShowCard
              venueName= {show.venue_name}
              date={show.date}
              city={show.city}
              other_artists={show.other_artists_msg}
              key={show.venue_name}
            />
          ))}; */}
          <h1>Check back later for more info</h1>
        </div>
      </div>
    </div>
  );
}

export default ShowPage;